import { HttpParams } from '@angular/common/http';

import { toHTTPParam } from '../../../../core';
import { Filter } from '../../../../models';
import { Cidade } from '../../../cidade';


export class LeadFilter implements Filter {
    isFilterDirty = false;

    idsLeads: number[] = [];
    origens: number[] = [];
    dataCadastroInicial: Date;
    dataCadastroFinal: Date;
    filterPsq: string;
    idsCampanhasOrigens: number[] = [];
    campanhaOrigemNull = false;
    somenteCampanhasQualificacaoEmAndamento = true;
    idsCampanhasQualificacoes: number[] = [];
    campanhaQualificacaoNull = false;
    idsCampanhasOrigensQualificacoes: number[] = [];
    campanhaOrigemQualificacaoNull = false;
    idsCanaisVendaOrigem: number[] = [];
    canaisMidiasSociais: number[] = [];
    canalMidiaSocialNull = false;
    tiposPessoas: number[] = [];
    cnpjCpf: string;
    email: string;
    telefoneCelular: string;
    idsEstados: number[] = [];
    idCidade: number;
    cidade: Cidade;
    idsCidadesSubRegioes: number[] = [];
    idsCidadesSubRegioesBairros: number[] = [];
    idsClassificacoes: number[] = [];
    classificacaoNull = false;
    idsUsuariosResponsaveis: number[] = [];
    temperaturas: number[] = [];
    idsRegioes: number[] = [];
    regiaoNull = false;
    somenteRegioesAtivas = true; // Para o multiselect das regiões

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // IDs Leads
        this.idsLeads?.forEach(idLead => {
            params = params.append('idLead', idLead.toString());
        });

        // Origens
        this.origens?.forEach(origem => {
            params = params.append('origem', origem.toString());
        });

        // Data Cadastro Inicial
        if (this.dataCadastroInicial) {
            params = params.append('dataCadastroInicial', toHTTPParam(this.dataCadastroInicial));
        }
        // Data Emissão Final
        if (this.dataCadastroFinal) {
            params = params.append('dataCadastroFinal', toHTTPParam(this.dataCadastroFinal));
        }

        // Filtro Pesquisa
        if (this.filterPsq && this.filterPsq.trim().length > 0) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // IDs Campanhas de origens
        this.idsCampanhasOrigens?.forEach(idCampanhaOrigem => {
            if (idCampanhaOrigem > 0) {
                params = params.append('idCampanhaOrigem', idCampanhaOrigem.toString());
            }
        });
        // Sem campanha de origem
        if (this.campanhaOrigemNull) {
            params = params.append('campanhaOrigemNull', 'true');
        }

        // IDs Campanhas de qualificações
        this.idsCampanhasQualificacoes?.forEach(idCampanhaQualificacao => {
            if (idCampanhaQualificacao > 0) {
                params = params.append('idCampanhaQualificacao', idCampanhaQualificacao.toString());
            }
        });
        // Sem campanha de qualificação
        if (this.campanhaQualificacaoNull) {
            params = params.append('campanhaQualificacaoNull', 'true');
        }

        // IDs Campanhas de origens e qualificações
        this.idsCampanhasOrigensQualificacoes?.forEach(idCampanhaOrigemQualificacao => {
            if (idCampanhaOrigemQualificacao > 0) {
                params = params.append('idCampanhaOrigemQualificacao', idCampanhaOrigemQualificacao.toString());
            }
        });
        // Sem campanha de origem e qualificação
        if (this.campanhaOrigemQualificacaoNull) {
            params = params.append('campanhaOrigemQualificacaoNull', 'true');
        }

        // Canais de Venda de Origem
        this.idsCanaisVendaOrigem?.forEach(idCanalVendaOrigem => {
            params = params.append('idCanalVendaOrigem', idCanalVendaOrigem.toString());
        });

        // Canais de Mídias Socias
        this.canaisMidiasSociais?.forEach(canalMidiaSocial => {
            if (canalMidiaSocial > 0) {
                params = params.append('canalMidiaSocial', canalMidiaSocial.toString());
            }
        });
        // Sem canal
        if (this.canalMidiaSocialNull) {
            params = params.append('canalMidiaSocialNull', 'true');
        }

        // Tipos Pessoas
        this.tiposPessoas?.forEach(tipoPessoa => {
            params = params.append('tipoPessoa', tipoPessoa.toString())
        });

        // CNPJ/CPF
        if (this.cnpjCpf && this.cnpjCpf.trim().length > 0) {
            params = params.append('cnpjCpf', this.cnpjCpf);
        }

        // E-mail
        if (this.email && this.email.trim().length > 0) {
            params = params.append('email', this.email);
        }

        // Telefone Celular
        if (this.telefoneCelular && this.telefoneCelular.trim().length > 0) {
            params = params.append('telefoneCelular', this.telefoneCelular);
        }

        // Estados
        if (this.idsEstados?.length > 0) {
            this.idsEstados.forEach(idEstado => {
                params = params.append('idEstado', idEstado.toString());
            });
        }

        // Cidade
        if (this.idCidade) {
            params = params.append('idCidade', this.idCidade.toString());
        }

        // Subregiões das cidades
        if (this.idsCidadesSubRegioes?.length > 0) {
            this.idsCidadesSubRegioes.forEach(idCidadeSubRegiao => {
                params = params.append('idCidadeSubRegiao', idCidadeSubRegiao.toString());
            });
        }

        // Bairros das subregiões das cidades
        if (this.idsCidadesSubRegioesBairros?.length > 0) {
            this.idsCidadesSubRegioesBairros.forEach(idCidadeSubRegiaoBairro => {
                params = params.append('idCidadeSubRegiaoBairro', idCidadeSubRegiaoBairro.toString());
            });
        }

        // Classificações
        this.idsClassificacoes?.forEach(idClassificacao => {
            if (idClassificacao > 0) {
                params = params.append('idClassificacao', idClassificacao.toString());
            }
        });
        // Sem classificação
        if (this.classificacaoNull) {
            params = params.append('classificacaoNull', 'true');
        }

        // Usuários Responsáveis
        this.idsUsuariosResponsaveis?.forEach(idUsuarioResponsavel => {
            params = params.append('idUsuarioResponsavel', idUsuarioResponsavel.toString());
        });

        // Temperaturas
        this.temperaturas?.forEach(temperatura => {
            params = params.append('temperatura', temperatura.toString());
        });

        // IDs regiões
        this.idsRegioes?.forEach(idRegiao => {
            if (idRegiao > 0) {
                params = params.append('idRegiao', idRegiao.toString());
            }
        });
        // Sem região
        if (this.regiaoNull) {
            params = params.append('regiaoNull', 'true');
        }

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.idsLeads = [];
        this.origens = [];
        this.dataCadastroInicial = null;
        this.dataCadastroFinal = null;
        this.filterPsq = null;
        this.idsCampanhasOrigens = [];
        this.campanhaOrigemNull = false;
        this.idsCampanhasQualificacoes = [];
        this.campanhaQualificacaoNull = false;
        this.idsCampanhasOrigensQualificacoes = [];
        this.campanhaOrigemQualificacaoNull = false;
        this.somenteCampanhasQualificacaoEmAndamento = true;
        this.idsCanaisVendaOrigem = [];
        this.canaisMidiasSociais = [];
        this.canalMidiaSocialNull = null;
        this.cnpjCpf = null;
        this.email = null;
        this.telefoneCelular = null;
        this.idsEstados = [];
        this.idCidade = null;
        this.cidade = null;
        this.idsCidadesSubRegioes = [];
        this.idsCidadesSubRegioesBairros = [];
        this.idsClassificacoes = [];
        this.classificacaoNull = false;
        this.idsUsuariosResponsaveis = [];
        this.temperaturas = [];
        this.regiaoNull = false;
        this.somenteRegioesAtivas = true;
    }
}
